//* ---------------------------------------
//  Vendors

import 'details-element-polyfill'
import 'focus-visible'
import 'focus-within-polyfill'
import 'objectFitPolyfill'
import 'whatwg-fetch'

//* ---------------------------------------
// Components

export const components = import.meta.globEager('../components/**/*.js')

//* ---------------------------------------
//  Render

export const render = (
    obj = components,
    selectorPrefix = ''
) => Object.keys(obj)
    .map(file => obj[file])
    .filter(component => component.default
        && component.selector)
    .map(component => Array
        .from(document.querySelectorAll(`
            ${selectorPrefix}${component.selector}`))
        .map(el => component.default(el)))

const renderedComponents = render(components)
    .flat()
    .filter(component => component)

//* ---------------------------------------
//  Hot Module Replacement

if (import.meta.hot) {
    import.meta.hot.accept()

    import.meta.hot
        .dispose((data) =>
            renderedComponents
                .filter(obj => typeof obj === 'object'
                    && obj.destroy)
                .forEach(obj => obj.destroy()))
}
